<div class="loading" [@animation]="visible ? 'visible' : 'invisible'">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</div>
